// extracted by mini-css-extract-plugin
export default {"schemas-container":"styles_schemas-container__d8Hpq","drawio-actions":"styles_drawio-actions__ZW59q","chat-btn":"styles_chat-btn__0QfgI","icon":"styles_icon__9XZyY"};